import InteractiveVideoPlane from "./InteractiveVideoPlane";

export default function RufflesCat({
  promptText = "Interactuar [E]",
  radius = 8,
  scaleMultiplier = 1,
  cameraOffset = [-5, 2, 0],
  cameraTransitionDuration = 1,
  ...props
}) {
  return (
    <InteractiveVideoPlane
      id="RufflesCat"
      videoSrc="/video/cat.webm"
      promptText={promptText}
      radius={radius}
      scaleMultiplier={scaleMultiplier}
      hudText="Ruffles Cat: prrrrr... perdí mi pelota de playa :'("
      cameraOffset={cameraOffset}
      cameraTransitionDuration={cameraTransitionDuration}
      {...props}
    />
  );
}
